import React, { Component } from 'react'
import './ccs-enrolment-occurrences.css'
import { FormButton, FormButtonContent } from '@myxplor/forms'
import { ContentToggleIcon } from '@myxplor/icons'
import { JSONTreeWrapped } from '../../../../../ui/json-tree'
import { addDaysToString } from '../../../../../week'

class OccurrenceRow extends Component {
  constructor(props) {
    super(props)
    this.toggle = this.toggle.bind(this)
    this.state = {
      detailsOpen: false,
    }
  }

  toggle() {
    this.setState({
      detailsOpen: !this.state.detailsOpen,
    })
  }

  determineEndDateDisplay = (endDate, arrangementEndDate) => {
    if (endDate === '0000-00-00' && arrangementEndDate === '0000-00-00') {
      return 'Present'
    } else if (endDate === '0000-00-00') {
      return addDaysToString(arrangementEndDate, 1)
    } else {
      return endDate
    }
  }

  render() {
    const {
      occurrence: { occurrence_number, start_date, end_date, status, previous_status, gov_record },
    } = this.props

    const { detailsOpen } = this.state

    return (
      <div className="enrolmentOccurrence-row">
        <div className="enrolmentOccurrence-item occurrenceNumber">{occurrence_number}</div>
        <div className="enrolmentOccurrence-item startDate">{start_date}</div>
        <div className="enrolmentOccurrence-item endDate">
          {this.determineEndDateDisplay(end_date, gov_record.arrangementEndDate)}
        </div>
        <div className="enrolmentOccurrence-item status">
          {status}
          {!previous_status ? null : (
            <span>
              &nbsp;(<strike>{previous_status}</strike>)
            </span>
          )}
        </div>
        <div className="enrolmentOccurrence-item details">
          <FormButton right className="occurrenceDetails--toggle" onClick={this.toggle}>
            <ContentToggleIcon right open={detailsOpen} />
            <FormButtonContent>{`${detailsOpen ? 'Hide' : 'View'} details`}</FormButtonContent>
          </FormButton>
        </div>
        <div className="enrolmentOccurrence-detail">
          {detailsOpen ? <JSONTreeWrapped data={gov_record} /> : null}
        </div>
      </div>
    )
  }
}

export default OccurrenceRow



// WEBPACK FOOTER //
// ./src/care-enrolments/details/ccs-gov-enrolments/ccs-enrolment-occurrences/views/occurrence-row.jsx